import { CountUp } from "countup.js";

export function initCountUp() {
	let countUps = [...document.getElementsByClassName('countUp')];

	// console.log('initCountUp: ', countUps);

	countUps.forEach(function(el) {
		let opts = {
			useGrouping: false,
			enableScrollSpy: true,
			scrollSpyOnce: true,
			scrollSpyDelay: 400,
			decimalPlaces: 0,
			separator: ''
		};

		if (el.dataset.decimal) {
			opts.decimalPlaces = el.dataset.decimal;
		}

		if (el.dataset.separator) {
			opts.separator = el.dataset.separator;
			opts.useGrouping = true;
		}

		// console.log(opts);

		new CountUp(el, parseInt(el.dataset.targetValue), opts);
	});
}
